import { IApontamentoHoras } from "../../../../Interfaces/AssistenciaTecnica/Atendimento/ApontamentoHoras/ApontamentoHorasInterfaces";
import { ACESSOS } from "../../../../Routes/Acessos";
import {
    AbrirAtendimentoVinculadoService,
    ListarApontamentoDeHorasServices,
    ListarTipoCompromissoServices,
    ListarUsuariosAtivosComAcessoCasoServices,
} from "../../../../Services/AssistenciaTecnica/Atendimento/ApontamentoHoras/ApontamentoHorasServices";
import { Controller } from "../../../Controller";

export async function ListarApontamentoDeHorasController(idCaso: number) {
    return Controller(ListarApontamentoDeHorasServices(idCaso));
}

export async function RegistrarApontamentoDeHorasController(
    requestBody: IApontamentoHoras
) {
    return Controller(AbrirAtendimentoVinculadoService(requestBody));
}

export async function ListarUsuariosAtivosController(idTipoCaso: number) {
    return Controller(ListarUsuariosAtivosComAcessoCasoServices(idTipoCaso));
}

export const ListarUsuariosAtivosComAcessoCasoController = async () =>
    ListarUsuariosAtivosController(ACESSOS.ASSISTENCIA.ID_MODULO);

export const ListarUsuariosAtivosComAcessoCasoVistoriaController = async () =>
    ListarUsuariosAtivosController(ACESSOS.ENTREGA_DE_CHAVES.ID_MODULO);

export const ListarUsuariosLembretesController = async () =>
    ListarUsuariosAtivosController(0);

export async function ListarTipoCompromissoController() {
    return Controller(ListarTipoCompromissoServices());
}
